import { useEffect } from 'react';

import type { PartyType } from '@/lib/auth/session';
import { useTodoCounts } from '@/lib/useTodoCounts';

/**
 * 현장 하나의 할 일 수를 위로 올린다 — 그리지는 않는다. 관문이 배정된 현장마다 하나씩 세운다.
 *
 * <p>훅은 반복문 안에서 부를 수 없어 현장마다 컴포넌트를 둔다. 세는 규칙은 사이드바와 같은 {@code useTodoCounts}.
 */
export function SiteTodoProbe({
  siteId,
  partyType,
  onCounts,
}: {
  siteId: string;
  partyType: PartyType;
  onCounts: (siteId: string, counts: Record<string, number>) => void;
}) {
  const counts = useTodoCounts(siteId, partyType);
  const signature = JSON.stringify(counts);
  useEffect(() => {
    onCounts(siteId, JSON.parse(signature) as Record<string, number>);
  }, [siteId, signature, onCounts]);
  return null;
}
